<template>
  <footer class="footer">
    <a accesskey="b" class="accesskey" id="accesskey_b" href="javascript:void(0);" title="頁尾網站資訊"
      onclick="document.getElementById('accesskey_b').scrollIntoView();">
      :::
    </a>
    <div class="container">
      <div class="box">
        <ul class="list">
          <li v-for="(item, index) in listItems" :key="index">
            <img :src="item.src" />
            <p>{{ item.text }}</p>
          </li>
        </ul>
        <div class="social_list">
          <a v-for="(item, index) in socialItems" :key="index" :href="item.to" :title="item.title + '(另開新視窗)'"
            target="_blank">
            <img :src="item.src" :alt="item.title" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      listItems: [
        {
          src: require("/public/img/icon_email.svg"),
          text: "itc@my.nthu.edu.tw",
        },
        { src: require("/public/img/icon_phone.svg"), text: "+886-3-5162453" },
        {
          src: require("/public/img/icon_address.svg"),
          text: "國立清華大學全球事務辦公室 臺灣新竹市光復路二段101號",
        },
      ],
      socialItems: [
        {
          to: "https://zh-tw.facebook.com/people/Global-Affairs-National-Tsing-Hua-University-%E5%9B%9B%E6%B5%B7%E5%90%8C%E6%96%B9/100057749195868/#",
          title: "fb",
          src: require("/public/img/icon_fb.svg"),
        },
        {
          to: "https://www.instagram.com/nthuoga/",
          title: "ig",
          src: require("/public/img/icon_ig.svg"),
        },
        {
          to: "https://www.youtube.com/channel/UCjaf371JsfFmBZ6e1vMl1Nw",
          title: "youtube",
          src: require("/public/img/icon_youtube.svg"),
        },
        {
          to: "https://www.threads.net/@nthuoga?xmt=AQGz5FeYM3l3MXlc41vArPNDdktfeqREq2lRYHQV44k9EqE",
          title: "threads",
          src: require("/public/img/icon_threads.svg"),
        },
      ],
    };
  },
  methods: {},
};
</script>
